export default function WhyDailyEmails() {
  const reasons = [
    {
      number: '01',
      title: 'Compliance-Based Industries Require Trust',
      description: 'Fire protection and life safety aren\'t impulse purchases. Customers need to trust that you understand regulations, standards, and the critical nature of their systems.',
      icon: 'ri-shield-check-line'
    },
    {
      number: '02',
      title: 'Long Sales Cycles',
      description: 'Service agreements and major projects don\'t happen overnight. Daily emails keep you present throughout the decision-making process.',
      icon: 'ri-time-line'
    },
    {
      number: '03',
      title: 'Recurring Inspections',
      description: 'Your customers need annual, semi-annual, or quarterly inspections. Regular communication ensures they remember who to call when it\'s time.',
      icon: 'ri-repeat-line'
    },
    {
      number: '04',
      title: 'Decision-Makers Need Reminders',
      description: 'Facility managers, building owners, and safety directors juggle dozens of priorities. Your emails keep fire protection on their radar.',
      icon: 'ri-user-star-line'
    },
    {
      number: '05',
      title: 'Staying Top-of-Mind Prevents Churn',
      description: 'When customers hear from you regularly, they\'re less likely to switch providers or respond to competitor outreach.',
      icon: 'ri-mind-map'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Why Daily Emails Work in Life Safety
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Fire protection is different. Your marketing should be too.
          </p>
        </div>

        <div className="space-y-8 mb-16">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow flex items-start gap-6"
            >
              <div className="flex-shrink-0">
                <div className="w-16 h-16 flex items-center justify-center bg-red-600 text-white rounded-lg">
                  <i className={`${reason.icon} text-3xl`}></i>
                </div>
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-4 mb-3">
                  <span className="text-5xl font-bold text-gray-200">{reason.number}</span>
                  <h3 className="text-2xl font-bold text-gray-900">{reason.title}</h3>
                </div>
                <p className="text-lg text-gray-600 leading-relaxed">{reason.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-red-600 text-white p-12 rounded-lg">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold mb-6">Email Is Owned Media</h3>
            <p className="text-xl leading-relaxed mb-4">
              Social media algorithms change. Search rankings fluctuate. But email? You own the relationship.
            </p>
            <p className="text-lg text-red-100">
              Every message lands directly in your customer's inbox. No middleman. No algorithm. Just you and them.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}